import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteCEPPStatusResult } from '../types/IActivityLog';

export class ActivityLogDeleteSiteRequest extends Request<{}, ISiteCEPPStatusResult> {
    constructor() {
        super('deleteSiteFromCEPP', {});
    }
}
